import React, { useCallback } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { useFlagMessageContext } from './utils/utils';

const FlagDetailsFlow = ({ intl }) => {
  const { flagMessage, setUserComment, userComment } = useFlagMessageContext();

  const handleChange = useCallback((e) => {
    setUserComment(e.target.value);
  }, [userComment]);

  return <div className="flag-message-modal-body">
    <p className="flag-message-modal-text with-back-button">
      <FormattedMessage
        id="stream.flag_message.select_reason"
        defaultMessage="Please select the issue you are having. This will only be shared with Peerspace."
      />
    </p>
    <hr className="no-margin" />
    <div className="flag-message-modal-textarea-container">
      <textarea
        className="form-textarea form-control"
        value={userComment}
        onChange={handleChange}
        placeholder={intl.formatMessage({ id: 'stream.flag_message.flag_message_placeholder', defaultMessage: 'Provide details here...' })}
      />
    </div>
    <hr className="no-margin" />
    <div className="flag-message-modal-footer flex end">
      <button
        className="btn btn-secondary"
        type="button"
        onClick={flagMessage}
      >
        <FormattedMessage id="stream.flag_message.submit" defaultMessage="Submit" />
      </button>
    </div>
  </div>;
};

exports.FlagDetailsFlow = injectIntl(FlagDetailsFlow);

FlagDetailsFlow.propTypes = {
  intl: intlShape
};
